const invoiceNoRegex = /^[^0-9\n\s]{0,12}[0-9]{1,16}$/

export default {

  shortText: (value) => {
    if (!value) {
      return false
    }

    if (value.trim().length > 64) {
      return 'Too long'
    }

    if (value.trim().length < 1) {
      return 'Enter a value'
    }

    return true
  },

  email: (email) => {
    // if (email.trim() === '') {
    //   return null
    // }

    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  },

  password: (password) => {
    if (!password || password.trim() === '') {
      return null
    }

    const length = password.length
    if (length < 7) {
      return 'Password has to be at least 8 characters long.'
    } else if (length > 33) {
      return 'Password has to be not longer than 32 characters.'
    }

    return true
  },

  name: name =>
    (name === '' || name === null)
      ? null
      : (typeof name === 'string' && name.replace(/\d/g, '').length > 0),

  invoiceNo: number => invoiceNoRegex.test(number) ? true : 'Use ABC000123 format for invoice number',
}



// WEBPACK FOOTER //
// ./src/views/utils/validate.js